import { render } from "./HistorySvg.vue?vue&type=template&id=1c3c3e65&bindings={}"
import script from "./HistorySvg.vue?vue&type=script&lang=ts"
export * from "./HistorySvg.vue?vue&type=script&lang=ts"
script.render = render

export default script